export default "dist/assets/images/vault.656a0cabfba2897861e791309dd024d8.svg";